export default "__VITE_ASSET__CSgmU8BG__"